import {FC} from 'react'
import { getStyledGlassBackground, IGlassMargin } from '../../styled-components/Glass.styled'

export interface GlassProps {
    children?: JSX.Element
    margin?: IGlassMargin
}

export const Glass: FC<GlassProps> = ({children, margin}) => {

    const StyledGlass = getStyledGlassBackground(margin)

    return(
        <StyledGlass>
            {children}
        </StyledGlass>
    )
}